import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import CaseStudiesPage from "../pages/case-studies/page";
import ContactPage from "../pages/contact/page";
import NewsPage from "../pages/news/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/case-studies", element: <CaseStudiesPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/news", element: <NewsPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
